import React, {useState} from 'react';
import {Section, Explanation_text, Info, Loader} from '../../../components';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import axios from 'axios';


export default function Shared_list(props){
  const[loading, setLoading]=useState(false);
  const[invitation, setInvitation]=useState(undefined);
  const[seconds_left, setSecondsLeft]=useState(undefined);
  let path=props.match.params.path;
  let user_id=props.match.params.user_id;

  let invited_by=null;
  let list_name=null;

  if(invitation==undefined){
    axios.get('/api/shareList/'+path+'/'+user_id).then((response)=>{
      setInvitation(response.data);
      setSecondsLeft(Math.round(response.data.total/3));
    });
    setInvitation('loading');
  }

  function acceptList(){
    setLoading(true);
    axios.post('/api/shareList/'+path+'/'+user_id).then((response)=>{
      let x=1;
      window.setTimeout(function(){window.location.href='/';},seconds_left*1000);
    while(x<seconds_left){
      let xx=seconds_left- x;
      window.setTimeout(function(){setSecondsLeft(xx);},x*1000);
      x+=1;
    }});
  }

  return(
    <Section icon={<MenuBookIcon/>} title='accept_shared_list_title' maxWidth='600px'>
      {(invitation==undefined || invitation=='loading')?null:<Typography>{invitation.user.first_name+' '+invitation.user.last_name+' invited you to download a list: "'+invitation.list.name+'" ('+invitation.total+' prospects). Do you wish to accept?'}</Typography>}
      <Grid container style={{marginTop:'30px'}}>
            <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><Button variant='contained' color='primary' onClick={()=>{acceptList();}}>Yes</Button></Grid>
            <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><Button variant='contained' color='secondary' onClick={()=>{props.history.push('/')}}>No</Button></Grid>
      </Grid>
      <Loader loading_message={"This operation will take "+seconds_left+" seconds to complete"} loading={loading}/>
    </Section>
  )
}
